var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("titles.pricing_sales")) + " "),
          _c("w-spacer"),
          _c(
            "w-dropdown",
            {
              attrs: {
                items: _vm.dropdownItems,
                right: "",
                "use-link": "",
                sm: "",
              },
              on: {
                click: function ($event) {
                  return $event()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "bars" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-wrap": "" } },
                    [
                      _c("w-tabs", {
                        attrs: { tabs: _vm.tabNames },
                        model: {
                          value: _vm.selectedTab,
                          callback: function ($$v) {
                            _vm.selectedTab = $$v
                          },
                          expression: "selectedTab",
                        },
                      }),
                      _vm.showAddPriceButton
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("tooltip.add-price-category"),
                                  expression:
                                    "$ct('tooltip.add-price-category')",
                                },
                              ],
                              style: { marginTop: "0px", flexShrink: 0 },
                              attrs: { round: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.addPriceCategory()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "plus" } })],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("app-sell-price", {
            key: _vm.selectedPriceCategory,
            ref: "sellPrice",
            attrs: {
              product: _vm.product,
              "price-category": _vm.selectedPriceCategory,
            },
          }),
          _c("app-price-category-sales-dates-edit", {
            attrs: {
              product: _vm.product,
              "price-category": _vm.selectedPriceCategory,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }